import { Component, Input, OnInit ,Output,EventEmitter, HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, MenuController, ModalController } from '@ionic/angular';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';


@Component({
  selector: 'app-inventory-checkout',
  templateUrl: './inventory-checkout.component.html',
  styleUrls: ['./inventory-checkout.component.scss'],
})
export class InventoryCheckoutComponent  implements OnInit {

  @Input() load;
  @Output() submit = new EventEmitter();
  is_footer = true;
  expanded = false;

  constructor(public modalCtrl: ModalController, public storage: Storage, public alertCtrl: AlertController, public ngcart: CartService, public db: DataService, private menuCtrl: MenuController, private loadingCtrl: LoadingController, private router: Router) {

  }

  ngOnInit() {
    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }

  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }

  submit_products(){
    let data = {status :'success'}
    this.modalCtrl.dismiss(data)
  }

}
